/** Extract the common props from a large object of props */
export var forwardCommonProps = function (props) {
    var id = props.id, className = props.className, tabIndex = props.tabIndex, dataQa = props.dataQa, dataTestId = props["data-testid"];
    return {
        id: id,
        className: className,
        tabIndex: tabIndex,
        'data-qa': dataQa,
        'data-testid': dataTestId,
    };
};
export var vaporwaveIconSizes = {
    small: 16,
    medium: 24,
    large: 48,
    'x-large': 68,
};
